"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MakeCtaFromBase = exports.BaseCta = void 0;
var React = require("react");
var styles = require("./BaseCta.scss");
var BaseCtaProps_1 = require("./BaseCtaProps");
var Reporting_1 = require("../../../helpers/Reporting");
var TabWatcher_1 = require("../../../helpers/TabWatcher");
var Focus_1 = require("../../../helpers/Functions/Focus");
var Join_1 = require("../../../helpers/Functions/Join");
var Refs_1 = require("../../../helpers/Functions/Refs");
var Simplify_1 = require("../../../helpers/Functions/Simplify");
TabWatcher_1.TabWatcher.initialize();
/** A CTA without any styling. */
exports.BaseCta = MakeCtaFromBase(function (props) { return ({ props: props, classes: styles.baseCta }); });
function MakeCtaFromBase(customizer) {
    if (customizer === void 0) { customizer = function (props) { return ({ props: props }); }; }
    return React.forwardRef(function (allProps, ref) {
        var _a = customizer(allProps), props = _a.props, classes = _a.classes, prepend = _a.prepend, append = _a.append;
        // Separate the properties that will be passed to the CTA directly. Parse the rest manually.
        var _b = Simplify_1.simplify(props), children = _b.children, _c = _b.onDark, onDark = _c === void 0 ? false : _c, appsDownload = _b.appsDownload, _d = _b.suppressLinkClick, suppressLinkClick = _d === void 0 ? false : _d, _e = _b.name, name = _e === void 0 ? typeof props.children === "string" ? props.children : undefined : _e, position = _b.position, url = _b.url, prefix = _b.urlPrefix, onClick = _b.onClick, className = _b.className, style = _b.style, _f = _b.openInNewWindow, openInNewWindow = _f === void 0 ? false : _f, _g = _b.link, link = _g === void 0 ? props.overrideLink ? true : !props.onClick && Boolean(props.url) : _g, _h = _b.overrideLink, overrideLink = _h === void 0 ? false : _h, _j = _b.disabled, disabled = _j === void 0 ? false : _j, deviceOptimization = _b.deviceOptimization, mediaType = _b.mediaType, download = _b.download, relationship = _b.relationship, autoFocus = _b.autoFocus, form = _b.form, _k = _b.buttonType, buttonType = _k === void 0 ? "button" : _k, formAction = _b.formAction, formEncType = _b.formEncType, formMethod = _b.formMethod, formNoValidate = _b.formNoValidate, testId = _b.testId, passthrough = __rest(_b, ["children", "onDark", "appsDownload", "suppressLinkClick", "name", "position", "url", "urlPrefix", "onClick", "className", "style", "openInNewWindow", "link", "overrideLink", "disabled", "deviceOptimization", "mediaType", "download", "relationship", "autoFocus", "form", "buttonType", "formAction", "formEncType", "formMethod", "formNoValidate", "testId"]);
        var combinedOnClick = function (event) {
            if (!suppressLinkClick && name && Reporting_1.ReportingHelper.initialized) {
                Reporting_1.ReportingHelper.linkClick({
                    name: name,
                    position: position,
                    url: url,
                    prefix: prefix,
                });
            }
            if (onClick) {
                onClick(event);
            }
        };
        var handleKeyPress = function (event) {
            if (event.keyCode === 13 || event.keyCode === 32) {
                if (onClick) {
                    combinedOnClick(event);
                }
            }
        };
        var otherProps = link
            ? {
                href: (overrideLink && url) || (!overrideLink && !disabled) ? url : undefined,
                target: openInNewWindow ? "_blank" : undefined,
                rel: relationship,
                media: deviceOptimization,
                type: mediaType,
                download: download,
            }
            : {
                autoFocus: autoFocus,
                type: buttonType,
                form: form,
                formAction: formAction,
                formEncType: formEncType,
                formMethod: formMethod,
                formNoValidate: formNoValidate,
                formTarget: openInNewWindow ? "_blank" : undefined,
            };
        var lnkRole = props.role ? { role: props.role } : { role: "button" };
        var eleRole = link ? (overrideLink && onClick ? lnkRole : "") : "";
        var Element = link ? "a" : "button";
        var myRef = React.useRef(null);
        var opensInNewWindowText = overrideLink && openInNewWindow ? children + " (opens in a new window)" : "";
        var ariaProps = overrideLink && openInNewWindow ? { "aria-label": opensInNewWindowText } : {};
        React.useEffect(function () {
            if (link && autoFocus && myRef.current) {
                Focus_1.focus(myRef.current);
            }
        }, [autoFocus, link]);
        return (React.createElement(Element, __assign({ className: Join_1.join(onDark && BaseCtaProps_1.Classes.onDark, link && disabled && BaseCtaProps_1.Classes.disabled, className, classes, appsDownload === "google-lg" ? "" + styles.googlePlayLg : "", appsDownload === "apple-lg" ? "" + styles.appleAppStoreLg : "", appsDownload === "google-sm" ? "" + styles.googlePlaySm : "", appsDownload === "apple-sm" ? "" + styles.appleAppStoreSm : ""), "data-testid": testId, disabled: (!link && disabled) || undefined, onClick: combinedOnClick, style: style, ref: Refs_1.refs(myRef, ref) }, { tabIndex: overrideLink ? 0 : undefined }, {
            onKeyDown: link
                ? overrideLink && onClick
                    ? handleKeyPress
                    : undefined
                : undefined,
        }, passthrough, eleRole, otherProps, ariaProps),
            prepend,
            link && (prepend !== "" || append !== "") ? React.createElement("span", null, children) : children,
            append));
    });
}
exports.MakeCtaFromBase = MakeCtaFromBase;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/BaseCta/BaseCta.js
// module id = 356
// module chunks = 8